export default "__VITE_ASSET__TRksHKz8__"